export default function PromotionalFeatureCallout({
  icon,
  name,
  description,
  className,
}) {
  return (
    <div
      className={classnames(
        className,
        'flex flex-col items-center text-center',
      )}>
      <div className="flex items-center mb-5">{icon}</div>
      <h3 className="text-lg font-semibold leading-6">{name}</h3>
      <p className="text-lg text-gray-500 leading-6 w-80">{description}</p>
    </div>
  );
}
